import {
    JsonItem, PickListItem
} from "../../shared/entities/pick-list/pick-list.entities";

import {
    EditTableItem
} from "../../shared/components/edit-table/edit-table";



//Connections - table, controller, page
export class CabHubConnectionEntity
    extends EditTableItem {

    CabMemberUserId:
        number;

    CabMemberName:
        string;

    IsCurrentCabMember:
        boolean;

    HubId:
        number;

    HubShortName:
        string;

    StatusId:
        number;

    StartDate:
        string;

    EndDate?:
        string;

    AdminNotes?:
        string;

    OneMonthCheckInDate?:
        string | null;

    OneMonthCheckInNotes?:
        string | null;

    SixMonthCheckInDate?:
        string | null;

    SixMonthCheckInNotes?:
        string | null;

    AgreementUploadId?:
        string;

    CreateDate:
        string;

    LastModifiedDate:
        string;
}


export type CabHubScope =
    "admin" |
    "cab-member" |
    "hub-member" |
    "none";
export interface CabHubTrackingPageVm {
    RespondentName:
    string;

    Scope:
    CabHubScope;

    ReportingMonth:
    number;

    ReportingYear:
    number;

    ReportingMonthPickList: PickListItem[];
    ReportingYearPickList: PickListItem[];

    Connections:
    CabHubConnectionEntity[];

    ActiveSurveys:
    CabHubActiveSurveyRow[];

    CompletedSurveys:
    CabHubCompletedSurveyRow[];

    PickLists:
    JsonItem[];
}

export interface CabHubActiveSurveyRow {
    ConnectionId: number;

    CabMemberName: string;

    HubName: string;
    HubShortName: string;

    ReportingMonth: number;
    ReportingYear: number;

    CabSurveySubmitted: boolean;
    HubSurveySubmitted: boolean;
}

export interface CabHubCompletedSurveyRow {
    SurveyId: number;

    ConnectionId: number;

    SurveyType:
    "CAB" |
    "Hub";

    CabMemberName: string;

    HubName: string;
    HubShortName: string;

    ReportingMonth: number;
    ReportingYear: number;

    MetThisMonth: boolean;
    NotMetExplanation?: string;

    HoursWorked: number;

    AdditionalHoursCompensationRate?:
    number | null;

    AnticipatedHoursNextMonthId:
    number;

    ConsultationTypeIds:
    string;

    OtherConsultationType?:
    string;

    WorkDescription:
    string;

    SatisfactionRatingId:
    number;

    SatisfactionExplanation?:
    string;

    SupportRequested:
    boolean;

    SupportRequestExplanation?:
    string;

    TrainingNeededId:
    number;

    TrainingDescription?:
    string;

    SubmittedByUserId:
    number;

    SubmittedDate:
    string;
    SubmittedByName: string;
}

export interface CabHubMonthlySurveyEntity {
    Id?: number;

    CabHubConnectionId: number;

    ReportingMonth: number;
    ReportingYear: number;

    MetThisMonth?: boolean;
    NotMetExplanation?: string;

    HoursWorked: number;

    AdditionalHoursCompensationRate?: number | null;

    AnticipatedHoursNextMonthId: number;

    ConsultationTypeIds: string;

    OtherConsultationType?: string;

    WorkDescription: string;

    SatisfactionRatingId: number;
    SatisfactionExplanation?: string;

    SupportRequested?: boolean;
    SupportRequestExplanation?: string;

    TrainingNeededId: number;
    TrainingDescription?: string;

    SubmittedByUserId?: number;
    SubmittedDate?: string;
}

export interface CabHubSurveyPageVm {
    RespondentName: string;

    ConnectionId: number;

    CabMemberName: string;

    HubName: string;
    HubShortName: string;

    ReportingMonth: number;
    ReportingYear: number;

    Survey?: CabHubMonthlySurveyEntity;

    PickLists:
    JsonItem[];
   
}